import { FC, useMemo } from 'react'
import { Link } from 'react-router-dom';
import { useAuth } from '../../../app/modules/auth';
import { toAbsoluteUrl } from '../../helpers';
import { HeaderUserMenu } from '../../partials';
import AppsLauncher from '../../partials/layout/header-menus/AppsLauncher';

const Topbar: FC = () => {
  const { auth } = useAuth();

  const userMenuIcon = useMemo(() => (
    <div className="d-flex align-items-center justify-content-start flex-shrink-0">
      <img
        className="h-30px w-30px rounded flex-shrink-0"
        src={toAbsoluteUrl('media/avatars/blank.png')}
        alt="user avatar"
      />

      <span className="ms-2 d-none d-lg-inline text-white fs-5">
        {`${auth?.first_name?.charAt(0)}. ${auth?.last_name}`}
      </span>
    </div>
  ), [auth?.first_name, auth?.last_name]);


  return (
    <div className="d-flex align-items-center justify-content-end flex-wrap gap-3">
      <AppsLauncher />


      {auth && (
        <div
          id="kt_header_user_menu_toggle"
          className="d-flex align-items-center flex-shrink-0 ms-1 ms-lg-3"
          aria-label="Open user menu"
        >
          <button
            type="button"
            aria-label="Open user menu"
            className="btn btn-link symbol-30px symbol-md-40px p-0"
            data-kt-menu-trigger="click"
            data-kt-menu-attach="parent"
            data-kt-menu-placement="bottom-end"
          >
            {userMenuIcon}
          </button>

          <HeaderUserMenu />
        </div>
      )}
      {!auth && (
        <Link
          to="/auth/login"
          type="button"
          className="rounded-pill signin-btn flex-shrink-0"
        >
          Sign In
        </Link>
      )}
    </div>
  )
}

export { Topbar }
